import { Component } from '@angular/core';

@Component({
  selector: 'app-risk',
  imports: [],
  templateUrl: './risk.html',
  styleUrl: './risk.scss',
})
export class Risk {

}
